// Angular
import { Component, OnInit } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
import { User } from 'src/app/core/models';
// NGRX

@Component({
  selector: 'kt-user-profile2',
  templateUrl: './user-profile2.component.html',
})
export class UserProfile2Component implements OnInit {
  // Public properties
  user$!: Observable<User>;

  /**
   * Component constructor
   *
   * @param store: Store<AppState>
   */
  constructor() {}

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit(): void {}

  /**
   * Log out
   */
  logout() {}
}
